<template>
  <div class="py-4 container-fluid">
    <div class="mt-4 row">
      <div class="col-12">
        <div class="card">
          <div class="card-header border-bottom">
            <div class="user d-flex align-items-center">
              <div class="col-6">
                <h5 class="mb-0">Phonebots</h5>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table id="datatable-search" class="table table-flush">
              <thead class="thead-light">
                <tr>
                  <th>#</th>
                  <th>Phonebot</th>
                  <th>License/UserKey</th>
                  <th>Status</th>
                  <th>Created At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="vbots.length === 0">
                  <td colspan="6" class="text-center">No Phonebots found.</td>
                </tr>
                <tr v-for="vbot in vbots" :key="vbot.license_Key">
                  <td>{{ vbots.indexOf(vbot) + 1 }}</td> <!-- Automatically generated index -->
                  <td>{{ vbot.bezeichnung }}</td>
                  <td>{{ vbot.license_Key }}</td>
                  <td>{{ vbot.status }}</td>
                  <td>{{ formatDate(vbot.created_at) }}</td>
                  <td>
                    <!-- Edit Button -->
                    <button class="btn btn-sm btn-info" @click="editItem(vbot.license_Key)">
                      <i class="fas fa-pen"></i>
                    </button>

                    <!-- View Call Logs Button -->
                   
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';

export default {
  name: 'VbotsForGuest',
  data() {
    return {
      vbots: [],
      dataTable: null,
      role: '',
    };
  },

  async mounted() {
    await this.fetchVbots();
  },

  methods: {
    async fetchVbots() {
      try {
        // ✅ GEÄNDERT: Store-Dispatch statt userService
        const response = await this.$store.dispatch('vbot/getVbots');
        this.vbots = response;
        this.initializeDataTable();
      } catch (error) {
        console.error("Error fetching vbot data:", error);
      }
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString();
    },

    editItem(license_Key) {
      this.$router.push({ name: "EditVbotByGuest", params: { license_Key: license_Key } });
    },

    viewCallLogs(vid) {
      this.$router.push({ name: 'ViewCallLogs', params: { id: vid } });
    },

    initializeDataTable() {
      this.$nextTick(() => {
        if ($.fn.DataTable.isDataTable('#datatable-search')) {
          $('#datatable-search').DataTable().destroy();
        }

        this.dataTable = $('#datatable-search').DataTable({
          data: this.vbots,
          columns: [
            { 
              data: null,
              render: (data, type, row, meta) => {
                return meta.row + 1;
              }
            },
            { data: 'bezeichnung' },
            { data: 'license_Key' },
            { data: 'status' },
            { data: 'created_at' },
            {
              data: null,
              render: (data, type, row) => {
                return `
                  <button class='btn btn-info edit-btn' data-id='${row.license_Key}'>Edit</button>
                `;
              },
            },
          ],
        });

        $('#datatable-search tbody').on('click', '.edit-btn', (event) => {
          const vid = $(event.currentTarget).data('id');
          this.editItem(vid);
        });

        this.applyCustomBorders();
      });
    },

    refreshDataTable() {
      if (this.dataTable) {
        this.dataTable.clear().rows.add(this.vbots).draw();
      }
    },

    applyCustomBorders() {
      $('#datatable-search th, #datatable-search td').css({
        'border': '1px solid #dcdcdc',
        'padding': '10px',
      });

      $('#datatable-search td:first-child, #datatable-search th:first-child').css({
        'border-left': '2px solid #dcdcdc',
      });

      $('#datatable-search th').css({
        'border-top': '2px solid #dcdcdc',
      });
    },
  },
};
</script>

<style scoped>
/* Ensure table layout is fixed for better rendering */
#datatable-search {
  table-layout: fixed;
  width: 100%;
}

/* Optional: Style for buttons inside the table cells */
#datatable-search td button {
  margin-right: 5px;
}
</style>
